import { graphql, HttpResponse } from 'msw'
import { type EnrollmentJointDisclosuresData, type EnrollmentJointDisclosuresSubmitOutput } from '../../../../models'

export const getEnrollmentJointDisclosuresDataMock: EnrollmentJointDisclosuresData = {
  errors: [],
  isError: false,
  activePerson: {
    applicationId: '1234567890',
    path: '/enrollment/joint/disclosures',
    progress: 1,
    name: {
      firstName: 'John',
      lastName: 'Doe',
    },
    unacceptedInvestmentDisclosures: [
      {
        disclosureId: 'deposit-agreement',
        disclosureName: 'Deposit Agreement',
        disclosureUri: 'https://example.com/deposit-agreement.pdf',
      },
      {
        disclosureId: 'privacy-notice',
        disclosureName: 'Privacy Notice',
        disclosureUri: 'https://example.com/privacy-notice.pdf',
      },
    ],
  },
}

export const submitEnrollmentJointDisclosuresDataMock: EnrollmentJointDisclosuresSubmitOutput = {
  errors: [],
  isError: false,
  activePerson: {
    path: '/enrollment/joint/welcome',
  },
}

export const mockGetEnrollmentJointDisclosuresData = graphql.mutation('getEnrollmentJointDisclosuresData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: getEnrollmentJointDisclosuresDataMock } })
})

export const mockSubmitEnrollmentJointDisclosuresData = graphql.mutation('submitEnrollmentJointDisclosuresData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: submitEnrollmentJointDisclosuresDataMock } })
})

export const mockEnrollmentJointDisclosures = [
  mockGetEnrollmentJointDisclosuresData,
  mockSubmitEnrollmentJointDisclosuresData,
]
